module.exports = __webpack_public_path__ + "static/img/phone.4a13e9af.png";